import { render, staticRenderFns } from "./DispensingView.vue?vue&type=template&id=3c083e62"
import script from "./DispensingView.vue?vue&type=script&lang=js"
export * from "./DispensingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports